import {useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CircledIcon from '../../../components/CircledIcon';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Label from '../../../components/Label/Label';
import IconButton from '../../../components/IconButton';
import PopoverWithLinks from '../../widgets/PopoverLinks/PopoverLinks';


const HealthBenefits = () => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  
  const [showDetails2, setShowDetails2] = useState<boolean>(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };
  const toggleDetails2 = () => {
    setShowDetails2(!showDetails2);
  };

  return (


 

    
    <Container className={'px-0'}>
      <Row className={'mt-8'}>
          <Col className={'col-12 col-lg-6'}>
              <h6 className="text-20 pb-0 mb-0">Health Benefits</h6>
          </Col>
      </Row>
      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Medical</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails}
                >
                  Benefits Info
                </Label>
              </div>
            </div>
            <Container className={'px-0 py-0 mt-10'}>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>Your medical election includes prescription drug coverage.</li>
                      <li>If you are an active employee eligible for TRICARE due to military or prior military service, you may wish to consider the TRICARE Military Supplement Plan Option (based on your eligibility for this option). To learn more about the TRICARE Military Supplement Plan Option, go to the TRICARE Military Supplement Plan Option website at https://info.selmanco.com/delta-airlines.  IMPORTANT NOTE: If you access this site while making your medical coverage elections on Benefits Direct, your enrollment session may time-out after 10 minutes. You should save all Benefits Direct enrollment elections by selecting the “Submit” button before accessing the TRICARE Military Supplement website. You may also click here for additional information about this medical option.</li>

                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
             </Row>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-2'}>
              <Col lg={7} className="py-5"></Col>
              <Col lg={5} className="py-5">Per-pay-period</Col>
              </Row>
              <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={4}>
                  <div className={'d-flex align-items-center'}>Medical</div>
                </Col>                
                <Col lg={1}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={1} className="text-center">
                  You Only
                </Col>
                <Col lg={2} className="text-center">
                  You + Spouse
                </Col>
                <Col lg={2} className="text-center">
                  You + Child(ren)
                </Col>
                <Col lg={2} className="text-center">
                  You + Family
                </Col>
 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Copay Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $77.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $167.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $136.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $225.00
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Gold HSA</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $59.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $128.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $104.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $172.50
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Silver HSA</span></div></div>
                 </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $21.50
                </Col>
                <Col lg={2} className="text-center py-10 bg-primary text-white">
                    $46.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $37.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $61.50
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Delta Pilots - High Deductible Health Plan</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>              
                <Col lg={1} className="text-center py-10">
                    $59.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $128.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $104.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $173.00
                </Col> 
              </Row>
 

              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Delta Pilots Medical Plan</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>              
                <Col lg={1} className="text-center py-10">
                    $77.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $167.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $136.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $225.00
                </Col> 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                
                
                </Col>              
                <Col lg={1} className="text-center py-10">
                $0.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    
                </Col>
                <Col lg={2} className="text-center py-10">
                    
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col> 
              </Row>


            </Container> 
          </GenericCard>
        </Col>
      </Row>


      <Container className={'px-0 py-0 mt-10'}>
      <Row className={'mt-0'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Health Savings Account</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails2}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails2}
                >
                  Benefits Info
                </Label>


                

              </div>
            </div>
            <Row className={`expandable-wrapper mt-10 ${showDetails2 ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>If you elect a high deductible medical option, it features access to an individual health savings account through Optum Bank that may be funded with your pre-tax payroll deductions if you are on active payroll status. You must have an open HSA Account with Optum Bank to have pre-tax payroll deductions and Delta contributions (Delta Health Rewards and child funding) deposited to your account.</li>
                      <li>Your payroll deductions, Delta Health Rewards, child funding (if applicable) and direct deposits together should not exceed your maximum allowed contribution for the year ($4,300 for employee coverage or $8,550 for family coverage in 2025 plus an additional $1,000 catch-up contribution if you are age 55 or older).
                      Refer to www.irs.gov and Publication 969 for more information on determining your annual maximum. For additional information and answers to many HSA-related questions, click here.</li>
                      <li>If you are active and 65, click here.</li>
                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
             </Row>
            
            <div>
              <GenericCard variant='transperant' className={'border rounded-1 mt-10 custom-blockquote primary'}>
                
            <Row
                key='1'
                className={
                  'py-0 my-0 text-fs-6  lh-xs'
                }
              >  
                <Col lg={3} className="text-center">
                <strong> Minimum Annual Contribution </strong> <br></br>
                $1.00
                </Col>
                <Col lg={3} className="text-center">
                <strong> Maximum Annual Contribution</strong><br></br>
                $9,550.00
                </Col>
                <Col lg={3} className="text-center">
                <strong>Increment</strong> <br></br>$0.01 
                </Col>
                <Col lg={3} className="text-center">
                <strong>Your Election Per-pay-period</strong> Not Contributing
                </Col> 
            </Row>
              </GenericCard>
            </div>
          </GenericCard>
          </Col>
        </Row>
       </Container>

       <Container className={'px-0 py-0 mt-10'}>
        <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('tooth')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
                <div className="ms-4">
                  <h5>Dental</h5>
                </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
            
                </div>
              </div>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-2'}>
              <Col lg={7} className="py-5"></Col>
              <Col lg={5} className="py-5">Per-pay-period</Col>
              </Row>
              <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={4}>
                  <div className={'d-flex align-items-center'}>Dental</div>
                </Col>                
                <Col lg={1}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={1} className="text-center">
                  You Only
                </Col>
                <Col lg={2} className="text-center">
                  You + Spouse
                </Col>
                <Col lg={2} className="text-center">
                  You + Child(ren)
                </Col>
                <Col lg={2} className="text-center">
                  You + Family
                </Col>
 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Basic Dental Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $4.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $9.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $12.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $17.00
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Comprehensive Dental Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $10.50
                </Col>
                <Col lg={2} className="text-center py-10 bg-primary text-white">
                    $22.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $23.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $33.50
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Delta Pilots Medical Plan - Dental Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $4.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $8.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $9.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $13.00
                </Col> 
              </Row>         
          
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                     
                
                </Col>
                <Col lg={1} className="text-center py-10 ">
                    $0.00
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col>
                <Col lg={2} className="text-center py-10">
                    
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col> 
              </Row>
            </GenericCard>
            </Col>
            </Row>
             </Container>
             <Container className={'px-0 py-0 mt-10'}>
            <Row className={'mt-8'}>
              <Col className={'col-12'}>
                <GenericCard variant='transperant' className={'border rounded-1'}>
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('glasses')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                      <div className="ms-4">
                        <h5>Vision</h5>
                      </div>
                    </div>
                        <div className="d-flex align-items-center justify-content-end">
                        </div>
                    </div>

            <Row className={'d-none d-lg-flex mt-0 pb-2'}>
              <Col lg={7} className="py-5"></Col>
              <Col lg={5} className="py-5">Per-pay-period</Col>
              </Row>
              <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={4}>
                  <div className={'d-flex align-items-center'}>Vision</div>
                </Col>                
                <Col lg={1}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={1} className="text-center">
                  You Only
                </Col>
                <Col lg={2} className="text-center">
                  You + Spouse
                </Col>
                <Col lg={2} className="text-center">
                  You + Child(ren)
                </Col>
                <Col lg={2} className="text-center">
                  You + Family
                </Col>
               </Row>
               <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Vision</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $3.37
                </Col>
                <Col lg={2} className="text-center py-10">
                     $6.39
                </Col>
                <Col lg={2} className="text-center py-10">
                    $6.73
                </Col>
                <Col lg={2} className="text-center py-10">
                     $9.80
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    
                
                </Col>
                <Col lg={1} className="text-center py-10 bg-primary text-white">
                    $0.00
                </Col>
                <Col lg={2} className="text-center py-10">
                      
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col>
                <Col lg={2} className="text-center py-10">
                      
                </Col> 
              </Row>
            </GenericCard>
            </Col>
            </Row>
             </Container>




    </Container>







  )
}

export default HealthBenefits